/** Приоритет transient UI: dropdown, popover, fullscreen picker. */
export const APP_BACK_TRANSIENT_PRIORITY = 300;

/** Приоритет app-level overlay stack: window/dialog/bottom sheet. */
export const APP_BACK_OVERLAY_PRIORITY = 200;
